import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";
import { authService } from "@/services/auth.service";
import { useAuthenticationStore } from "./authentication";
import type { GetSchoolDetails } from "@/api_types/school";
import { useSchoolStore } from "./school";

function districtAuthTypeFromTokenOrStore(authStore: ReturnType<typeof useAuthenticationStore>): string {
  try {
    const t = authStore.getToken()?.access_token;
    if (t) {
      const p = authService.parseJwt(t) as { authentication_type?: string };
      if (typeof p?.authentication_type === "string") {
        return p.authentication_type.toLowerCase();
      }
    }
  } catch {
    /* ignore */
  }
  const raw = authStore.jwtData?.authentication_type;
  return typeof raw === "string" ? raw.toLowerCase() : "";
}

export const useDistrictStore = defineStore("district", {
  state: () => {
    return {
      account: "",
      schools: [] as GetSchoolDetails[]
    };
  },

  actions: {
    async fetchSchools(): Promise<GetSchoolDetails[]> {
      const authStore = useAuthenticationStore();
      const schoolStore = useSchoolStore();
      
      if (
        (schoolStore.school?.is_district == "yes" || schoolStore.school?.is_district == true) &&
        districtAuthTypeFromTokenOrStore(authStore) === "district"
      ) {
        console.log("Fetching schools for district inside the store");
        const res =
          (await FetchService.fetchData("/schools", "get"))?.filter?.(
            (i) => i.school_id !== schoolStore.school?.school_id
          ) || [];
        console.log(res);
        this.schools = res;
        return res;
      }
      
      this.schools = [];
      return [];
    }
  }
});